import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../../../../components/Converter";
import KiloNewtonDividedByMetreSquared from "../../../../../../components/Math/Units/Metric/KiloNewtonDividedByMetreSquared";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import { decimalSeparator, thousandSeparator } from "../../../../../../i18n";
import {
  selectUndraenierteScherfestigkeit,
  setUndraenierteScherfestigkeit,
} from "../../../../../../store/slices/innereSlice";

function UndraenierteScherfestigkeit() {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const undraenierteScherfestigkeit = useSelector(selectUndraenierteScherfestigkeit);

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterSoil.undrainedCohesion")}</p>}
      indicesValue={
        <span>
          c<sub>u,k</sub>
        </span>
      }
      inputValue={
        <NumberFormat
          className={getClassName(undraenierteScherfestigkeit)}
          value={undraenierteScherfestigkeit}
          decimalSeparator={decimalSeparator()}
          thousandSeparator={thousandSeparator()}
          displayType="input"
          type="text"
          onValueChange={(value) => dispatch(setUndraenierteScherfestigkeit(value.floatValue))}
          allowNegative={true}
        />
      }
      unitValue={<KiloNewtonDividedByMetreSquared />}
    />
  );
}

export default UndraenierteScherfestigkeit;
